import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CareType } from '../higherEd';

export type GetPatientDetailsResponse = {
  data: {
    userId: string;
    autopayEnabled: boolean;
    nonpaymentDeactivationEnabled: boolean;
    onboardingCaretypeSelection: CareType;
    onboardingRecommendedCaretype: CareType;
  };
};

export const getPatientDetails = async (patientId: string) => restClient.request<GetPatientDetailsResponse>(`/api/v1/patient/${patientId}/details`);

export type UpdatePatientDetailsInput = Partial<{
  onboardingCaretypeSelection: CareType | null;
  onboardingRecommendedCaretype: CareType | null;
}>;

export const updatePatientDetails = (patientId: string, details: UpdatePatientDetailsInput) => restClient.request(`/api/v1/patient/${patientId}/details`, {
  method: 'PATCH',
  data: snakecaseKeys(details),
});
